import api from "./api";
import auth from "./auth";

const BASE_SERVICE_URL = "points-service/capping/";
const MERCHANT_AUTH = "merchant-auth-service/";

export default {
    getAmountCapping: function() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "view/amount",
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    saveAmountCapping: function(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "update",
                param,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getTransactionCapping: function() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "view/transaction",
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    saveTransactionCapping: function(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "update",
                param,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getNotificationCapping: function() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "notification/view",
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getUsers: function(keyword) {
        return new Promise((resolve, reject) => {
            api.post(MERCHANT_AUTH + "user/lists",
                keyword,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    saveNotificationCapping: function(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "notification/update",
                param,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
}